import * as actionTypes from '../actionTypes/ditto';

export function addNewDitto(dittoId) {
    return { type: actionTypes.ADD_DITTO_LOAD, dittoId };
}

export function saveUpdateDitto(dittoId) {
    return { type: actionTypes.SAVE_UPDATE_DITTO_LOAD, dittoId };
}
